module.exports = __webpack_public_path__ + "static/img/instruction.4daa5295.png";